import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { AES_URL_STORAGE_KEY, JWT_STORAGE_KEY, SESSION_STORAGE_KEY } from '@core/constants';
import { SessionService } from '@state/session/session.service';

/**
 * Guard de la ruta /login: si hay sesión almacenada, restaura las credenciales
 * en el store y redirige a /agenda devolviendo un UrlTree.
 *
 * La redirección DEBE ser declarativa: el router la encadena dentro de la misma
 * navegación inicial. El navigateRoot imperativo que antes vivía en el ngOnInit
 * del LoginPage cancelaba la navegación inicial a medias y dejaba el outlet de
 * Ionic desincronizado (login visible con URL /agenda), convirtiendo en no-op
 * los navigateRoot('/agenda') posteriores del botón de acceso.
 */
@Injectable({ providedIn: 'root' })
export class AutoLoginGuard {

    constructor(
        private router: Router,
        private sessionService: SessionService
    ) {
    }

    async canActivate(): Promise<boolean | UrlTree> {
        const [aesUrl, sessionId, jwtToken] = await Promise.all([
            Preferences.get({ key: AES_URL_STORAGE_KEY }),
            Preferences.get({ key: SESSION_STORAGE_KEY }),
            Preferences.get({ key: JWT_STORAGE_KEY })
        ]);

        // Sin sticky sessions la sesión almacenada puede ser solo el JWT: el
        // AuthGuard de /agenda lo restaura en sessionStorage y lo valida
        if (aesUrl.value && (sessionId.value || jwtToken.value)) {
            this.sessionService.update({
                aesUrl: aesUrl.value,
                sessionId: sessionId.value || ''
            });

            // La validación contra el servidor la hace el AuthGuard de /agenda
            return this.router.parseUrl('/agenda');
        }

        return true;
    }
}
